import { NgIf, NgStyle } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { LocalizationPipe } from '@shared/modules/localization';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'ui-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, NgStyle, NzModalModule, NzSpinModule, NzIconModule, LocalizationPipe],
})
export class UIModal {
  @Input() visible = true;
  @Input() loading?: boolean;
  @Input() title?: string | TemplateRef<NonNullable<unknown>>;
  @Input() description?: string;
  @Input() titleAlign: 'left' | 'center' | 'right' = 'left';
  @Input() footer?: string | TemplateRef<NonNullable<unknown>> | null = null;
  @Input() width: number | string = 520;
  @Input() height = 'auto'; // not in a percent
  @Input() draggable = false; // Whether modal is draggable or not
  @Input() closable = true; //Whether a close (x) button is visible on top right of the modal dialog or not
  @Input() centered = true;
  @Input() mask = true; // Whether show mask or not.
  @Input() maskClosable = true; // Whether to close the modal dialog when the mask (area outside the modal) is clicked
  @Input() escToClose = true; // Whether support press esc to close

  @Output() afterClose = new EventEmitter<void>();

  get isTitleText(): boolean {
    return typeof this.title === 'string';
  }

  get titleTemplateRef() {
    return this.isTitleText ? undefined : this.title;
  }

  onAfterClose(): void {
    this.afterClose.emit();
  }

  onClose(): void {
    if (!this.closable) {
      return;
    }
    this.visible = false;
  }
}
